module.exports = __webpack_public_path__ + "img/flag_167.73e7c58a.png";